import { render, staticRenderFns } from "./TheHeaderTopbarProfile.vue?vue&type=template&id=606b8163&"
import script from "./TheHeaderTopbarProfile.vue?vue&type=script&lang=js&"
export * from "./TheHeaderTopbarProfile.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderTopbarProfile.vue?vue&type=style&index=0&id=606b8163&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports